export default __webpack_public_path__ + "static/P_SearchThumb_IN-8001HD-1e251014a72769d7c6630f7355fed26f.webp";